// extracted by mini-css-extract-plugin
export default {"MedicalPanelContainer":"dACkpYV1"};